import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({

    state: {
        Token: '',
        mobile:''
    },
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin(state, user) {
            if(user.token){
                state.Token = user.token;
                state.mobile = user.mobile;
                localStorage.setItem('Token', user.token);
                Vue.prototype.$http.defaults.headers.token = user.token
            }

        },

        logout(state) {
            state.Token = '';
            state.mobile = '';
        	console.log('已经退出登录了');
            localStorage.removeItem('Token')
        	Vue.prototype.$http.defaults.headers.token = ''
        },
    }
});
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js